// helper functions - Updated for ES6 imports
// Usage:
// >> import { getShortDay, setViewportProperty } from "@/helpers";
// >> import helpers from "@/helpers"; // for the full object

// Individual helper functions
export function lastFive(str) {
  if (str.length < 5) return str;
  return str.substr(str.length - 5);
}

export function lastN(str, n) {
  if (str.length < n) return str;
  return str.substr(str.length - n);
}

export function firstN(str, n) {
  if (str.length < n) return str;
  return str.substr(0, n);
}

export function isValidJSON(str) {
  try {
    JSON.parse(str);
  } catch (e) {
    return false;
  }
  return true;
}

export function hexToRGB(hex) {
  var a = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
  return a
    ? {
        r: parseInt(a[1], 16),
        g: parseInt(a[2], 16),
        b: parseInt(a[3], 16),
      }
    : null;
}

export function textColor(bgColor) {
  if (!bgColor || !bgColor.startsWith("#")) return null;
  if (bgColor.length !== 7) return null;
  var rgb = hexToRGB(bgColor);
  var luminance = (0.299 * rgb.r + 0.587 * rgb.g + 0.114 * rgb.b) / 255;
  // console.log("rgb, luminance", rgb, luminance);
  if (luminance > 0.5) return "#222";
  return "lightgoldenrodyellow";
}

export function shortDate(timeString) {
  var dt = new Date(timeString);
  var date = dt.toLocaleString("en-GB").slice(0, 5);
  return date;
}

export function googleMapsDirectionsURL(originCoords, destinationCoords) {
  // input are coords strings like
  var prefix = `https://www.google.com/maps/dir/?api=1&`;
  return `${prefix}origin=${originCoords}&destination=${destinationCoords}&travelmode=driving`;
}

// Extracted and exported the setViewportProperty function
export function setViewportProperty(doc) {
  var customViewportCorrectionVariable = "vh";
  var prevClientHeight;
  var customVar = "--" + (customViewportCorrectionVariable || "vh");

  function handleResize() {
    var clientHeight = doc.clientHeight;
    if (clientHeight === prevClientHeight) return;
    requestAnimationFrame(function updateViewportHeight() {
      doc.style.setProperty(customVar, clientHeight * 0.01 + "px");
      prevClientHeight = clientHeight;
    });
  }
  handleResize();
  return handleResize;
}

// Extracted checkViewportDelay as a separate function
export function checkViewportDelay(delay) {
  // console.log("checkViewportDelay", delay);
  setTimeout(() => setViewportProperty(document.documentElement), delay);
}

// Updated postCSSHack to use the exported functions
export function postCSSHack() {
  window.addEventListener(
    "resize",
    setViewportProperty(document.documentElement)
  );
  // setTimeout(() => setViewportProperty(document.documentElement), 3000)
  window.addEventListener("visibilitychange", () => checkViewportDelay(200));
  window.addEventListener("load", () => checkViewportDelay(500));
  checkViewportDelay(1000);
  checkViewportDelay(3000);
  checkViewportDelay(5000);
  checkViewportDelay(10000);
}

// Keep the original object structure as default export for backwards compatibility
const helpers = {
  lastFive,
  lastN,
  firstN,
  isValidJSON,
  hexToRGB,
  textColor,
  shortDate,
  googleMapsDirectionsURL,
  postCSSHack,
  setViewportProperty,
  checkViewportDelay,
};

export default helpers;
